import axios from 'axios';
import gsap from 'gsap';

export default () => {
  let scriptEl = document.getElementById('l-settings')
  eval(scriptEl.innerHTML);

  const posts_container = (document.querySelector('.clients')) ? document.querySelector('.clients') : document.querySelector('.news-inner');
  const loadMoreBtn = document.querySelector('.loadmore');
  const btnText = {
    loading: 'Loading...',
    load: 'Load more'
  };

  let status = true;

  document.addEventListener('scroll', ()=>{

    let coords = loadMoreBtn.getBoundingClientRect(),
        top = coords.bottom,
        height = document.documentElement.clientHeight,
        trigger = Math.round(top - height);
        //set triiger to 626- it is height of last card
        console.log(trigger)
    if(trigger <= 626 && top > 0 && status) {
    
      let isLoading = true;

      status = false;
      
      let data = new FormData();

      data.append('action', 'loadmore');
      data.append('query', window.settings.posts);
      data.append('page', window.settings.current_page);

      // console.log();
      

      axios({
        method: 'post',
        url: window.settings.ajaxurl,
        data: data,
        contentType: false,
        cache: false,
        processData: false,
        dataType: 'json',
        transformRequest: [
          function () {
            if (isLoading) {
              loadMoreBtn.innerHTML = btnText.loading;

              return data;
            }
          },
        ],
      })
        .then((response) => {
          status = true;

          if (response.data) {
            // posts_container.append(data.data); // insert new posts
            posts_container.insertAdjacentHTML('beforeend', response.data);
            window.settings.current_page++;
            showNewElements();

            if (window.settings.current_page == window.settings.max_page) {
              loadMoreBtn.remove();
            }; // if last page, remove the button

            return data;
          } else {
            loadMoreBtn.remove(); // if no data, remove the button as well
          }
          // preloader.style.display = 'none';
        })
        .catch(() => {
          // console.log('Catch');

          loadMoreBtn.innerHTML = btnText.load;
          let isLoading = false;
          // preloader.style.display = 'none';
        });

        
        
      }

  });

  function showNewElements() {
    let hideEl = document.querySelectorAll('[data-newItem="true"]');
    let iter;
   
    hideEl.forEach((el, index)=>{
        el.classList.contains('clients-item-link')?iter=index*1.1:iter = index
      gsap.to(el, {
        opacity: 1,
        duration: 1,
        delay: .15 * iter, 
        beforeStart: function() {
          el.removeAttribute('data-newItem');
        }
      });
    });
  }
};
